"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports.default = function () {
    (0, _jquery2.default)(":input[data-copy]", this).each(function () {
        var $t = (0, _jquery2.default)(this);
        var settings = $t.data("copy-settings");
        var source = (0, _jquery2.default)($t.attr("data-copy"));
        source.change(function () {
            var val = (0, _jquery2.default)(this).val();
            if (settings) {
                if (settings.sourceValueFilter) {
                    var patt = new RegExp(settings.sourceValueFilter);
                    if (patt.test(val)) return;
                }
                if (settings.targetValueFilter) {
                    var patt = new RegExp(settings.targetValueFilter);
                    if (patt.test($t.val())) return;
                }
            }
            $t.val(val).trigger("change");
        });
    });

    (0, _jquery2.default)(":input[data-kebap]", this).change(function () {
        var $t = (0, _jquery2.default)(this);
        $t.change(function () {
            if (this.interuptKebabProcess) return;
            var val = (0, _jquery2.default)(this).val();
            abp.services.api.cmsPage.toKebapString(val).done(function (result) {
                return $t.val(result);
            });
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/data-copy.js
// module id = 424
// module chunks = 0